var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDematImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 80,
    viewBox: "0 0 403 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9656 0C36.3706 0 43.744 1.64279 50.086 4.92836C56.5043 8.21394 61.4327 12.9131 64.8711 19.0258C68.3859 25.0621 70.1433 32.0917 70.1433 40.1146C70.1433 48.1375 68.3859 55.1671 64.8711 61.2034C61.4327 67.1633 56.5043 71.7861 50.086 75.0716C43.744 78.3572 36.3706 80 27.9656 80H0V0H27.9656ZM27.3926 66.361C35.7975 66.361 42.2923 64.0688 46.8768 59.4842C51.4613 54.8997 53.7536 48.4432 53.7536 40.1146C53.7536 31.7861 51.4613 25.2913 46.8768 20.6304C42.2923 15.893 35.7975 13.5244 27.3926 13.5244H16.0458V66.361H27.3926Z",
    fill: "url(#paint0_linear_1136_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.166 13.0472V33.0758H129.062V45.7797H102.166V66.9528H132.495V80H86.1436V0H132.495V13.0472H102.166Z",
    fill: "url(#paint1_linear_1136_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.715 0V80H219.669V27.9656L198.236 80H186.087L164.54 27.9656V80H148.494V0H166.718L192.162 59.4842L217.606 0H235.715Z",
    fill: "url(#paint2_linear_1136_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.621 64.7783H273.805L268.54 80H251.716L280.443 0H299.098L327.825 80H310.886L305.621 64.7783ZM301.272 51.9599L289.713 18.5408L278.154 51.9599H301.272Z",
    fill: "url(#paint3_linear_1136_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M402.507 0V12.9513H381.189V80H365.143V12.9513H343.825V0H402.507Z",
    fill: "url(#paint4_linear_1136_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1136_2",
    x1: 70.1433,
    y1: 78.8034,
    x2: -1.78761,
    y2: 1.66697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1FFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1136_2",
    x1: 132.495,
    y1: 78.8034,
    x2: 64.4638,
    y2: 30.5934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1FFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1136_2",
    x1: 235.715,
    y1: 78.8034,
    x2: 166.494,
    y2: -13.4989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1FFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1136_2",
    x1: 327.825,
    y1: 78.8034,
    x2: 256.538,
    y2: -4.14396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1FFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1136_2",
    x1: 402.507,
    y1: 78.8034,
    x2: 330.823,
    y2: 14.4926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1FFED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDematImg);
export default __webpack_public_path__ + "static/media/demat-img.f8e2fe6f58067eea5204e8f8cd9a06c2.svg";
export { ForwardRef as ReactComponent };